import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  requestExportBiRun(
    request: Boundaries["requestExportBiRun"]["request"],
  ): void;
}

function useRequestExportBiRun(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isRequestExportBiRunRequestPending),
    isRequestSuccess: useSelector(selector.isRequestExportBiRunRequestSuccess),
    isRequestFailure: useSelector(selector.isRequestExportBiRunRequestFailure),
    requestExportBiRun: core.requestExportBiRun,
  };
}

export { useRequestExportBiRun };
